import { Segmenter } from './src/segmenter.js';
Object.defineProperty(Intl, 'Segmenter', {
    value: Segmenter,
    enumerable: false,
    writable: true,
    configurable: true,
});
